import { lazy, Suspense } from 'react'
import Loading from '../components/Loading'

const Demo1 = lazy(() => import('../views/Demo1'))
const Demo2 = lazy(() => import('../views/Demo2'))
const Demo3 = lazy(() => import('../views/Demo3'))
const Menu = lazy(() => import('../views/menu'))
const Home = lazy(() => import('../views/home'))
const TimeList = lazy(() => import('../views/activity/TimeList'))
const Activity = lazy(() => import('../views/activity'))
const ActivityDetail = lazy(() => import('../views/activity/Profile'))
const ViewMore = lazy(() => import('../views/activity/ViewMore'))
const Catering = lazy(() => import('../views/catering'))
const Restaurant = lazy(() => import('../views/restaurant'))
const MyCenter = lazy(() => import('../views/center'))
const Facility = lazy(() => import('../views/facility'))
const FacilityDetail = lazy(() => import('../views/facility/detail'))
const Spa = lazy(() => import('../views/spa'))
const SpaMenu = lazy(() => import('../views/spa/SpaMenu'))
const SpaAbout = lazy(() => import('../views/spa/About'))

const ChatBox = lazy(() => import('../views/chat'))
const Discover = lazy(() => import('../views/discover'))
const Feedback = lazy(() => import('../views/feedback'))
const Souvenir = lazy(() => import('../views/souvenir'))
const Preview = lazy(() => import('../views/preview'))

const OrderDetail = lazy(() => import('../views/orders/Detail'))
const Coupons = lazy(() => import('../views/coupons'))
const Orders = lazy(() => import('../views/orders'))

const Housekeeping = lazy(() => import('../views/housekeeping'))
const Notification = lazy(() => import('../views/notification')) 
const RelateProduct = lazy(() => import('../views/home/RelateProduct'))
const Carte = lazy(() => import('../views/carte'))
const Map = lazy(() => import('../views/map'))
const Comments = lazy(() => import('../views/comments'))
const Albums = lazy(() => import('../views/albums'))
const ShuttleBus = lazy(() => import('../views/ShuttleBus'))
const Transfer = lazy(() => import('../views/Transfer'))
const Result = lazy(() => import('../views/result'))
const BusDetail = lazy(() => import('../views/ShuttleBus/BusDetail'))
const BusOrderList = lazy(() => import('../views/ShuttleBus/OrderList'))
const Voucher = lazy(() => import('../views/voucher'))

const Pdf = lazy(() => import('../views/pdf'))
const CustomerActivate = lazy(() => import('../views/customer/Activate'))
const Benefits = lazy(() => import('../views/customer/Benefits'))
const BenefitsIntro = lazy(() => import('../views/customer/Benefits/Intro'))
const BenefitsOutlet = lazy(() => import('../views/customer/Benefits/Outlet'))


const routeMap = [
    {
        path: '/demo1',
        component: (
            <Suspense fallback={<Loading />}>
                <Demo1 />
            </Suspense>
        )
    },
    {
        path: '/demo2',
        component: (
            <Suspense fallback={<Loading />}>
                <Demo2 />
            </Suspense>
        )
    },
    {
        path: '/demo3',
        component: (
            <Suspense fallback={<Loading />}>
                <Demo3 />
            </Suspense>
        )
    },
    {
        path: '/menu',
        component: (
            <Suspense fallback={<Loading />}>
                <Menu />
            </Suspense>
        )
    },
    {
        path: '/home',
        cacheFlag: true,
        component: (
            <Suspense fallback={<Loading />}>
                <Home />
            </Suspense>
        ),
    },
    {
        path: '/activity',
        component: (
            <Suspense fallback={<Loading />}>
                <Activity />
            </Suspense>
        )
    },
    {
        path: '/activity/time-list',
        component: (
            <Suspense fallback={<Loading />}>
                <TimeList />
            </Suspense>
        )
    },
    {
        path: '/activity/more',
        component: (
            <Suspense fallback={<Loading />}>
                <ViewMore />
            </Suspense>
        )
    },
    {
        path: '/activity/profile',
        component: (
            <Suspense fallback={<Loading />}>
                <ActivityDetail />
            </Suspense>
        )
    },
    {
        path: '/catering',
        component: (
            <Suspense fallback={<Loading />}>
                <Catering />
            </Suspense>
        )
    },
    {
        path: '/restaurant',
        component: (
            <Suspense fallback={<Loading />}>
                <Restaurant />
            </Suspense>
        )
    },
    {
        path: '/center',
        component: (
            <Suspense fallback={<Loading />}>
                <MyCenter />
            </Suspense>
        )
    },
    {
        path: '/facility',
        component: (
            <Suspense fallback={<Loading />}>
                <Facility />
            </Suspense>
        )
    },
    {
        path: '/facility/detail',
        component: (
            <Suspense fallback={<Loading />}>
                <FacilityDetail />
            </Suspense>
        )
    },
    {
        path: '/spa',
        component: (
            <Suspense fallback={<Loading />}>
                <Spa />
            </Suspense>
        )
    },
    {
        path: '/spa/menu',
        component: (
            <Suspense fallback={<Loading />}>
                <SpaMenu />
            </Suspense>
        )
    },
    {
        path: '/spa/about',
        component: (
            <Suspense fallback={<Loading />}>
                <SpaAbout />
            </Suspense>
        )
    },
    {
        path: '/chat',
        component: (
            <Suspense fallback={<Loading />}>
                <ChatBox />
            </Suspense>
        )
    },
    {
        path: '/discover',
        component: (
            <Suspense fallback={<Loading />}>
                <Discover />
            </Suspense>
        )
    },
    {
        path: '/feedback',
        component: (
            <Suspense fallback={<Loading />}>
                <Feedback />
            </Suspense>
        )
    },
    {
        path: '/souvenir',
        component: (
            <Suspense fallback={<Loading />}>
                <Souvenir />
            </Suspense>
        )
    },
    {
        path: '/preview',
        component: (
            <Suspense fallback={<Loading />}>
                <Preview />
            </Suspense>
        )
    },
    {
        path: '/order/detail',
        component: (
            <Suspense fallback={<Loading />}>
                <OrderDetail />
            </Suspense>
        )
    },
    {
        path: '/coupons',
        component: (
            <Suspense fallback={<Loading />}>
                <Coupons />
            </Suspense>
        )
    },
    {
        path: '/orders',
        component: (
            <Suspense fallback={<Loading />}>
                <Orders />
            </Suspense>
        )
    },
    {
        path: '/housekeeping',
        component: (
            <Suspense fallback={<Loading />}>
                <Housekeeping />
            </Suspense>
        )
    },
    {
        path: '/notification',
        component: (
            <Suspense fallback={<Loading />}>
                <Notification />
            </Suspense>
        )
    },
    {
        path: '/relate-product',
        component: (
            <Suspense fallback={<Loading />}>
                <RelateProduct />
            </Suspense>
        )
    },
    {
        path: '/carte',
        component: (
            <Suspense fallback={<Loading />}>
                <Carte />
            </Suspense>
        )
    },
    {
        path: '/map',
        component: (
            <Suspense fallback={<Loading />}>
                <Map />
            </Suspense>
        )
    },
    {
        path: '/comments',
        component: (
            <Suspense fallback={<Loading />}>
                <Comments />
            </Suspense>
        )
    },
    {
        path: '/albums',
        component: (
            <Suspense fallback={<Loading />}>
                <Albums />
            </Suspense>
        )
    },
    {
        path: '/transfer',
        component: (
            <Suspense fallback={<Loading />}>
                <Transfer />
            </Suspense>
        )
    },
    {
        path: '/result',
        component: (
            <Suspense fallback={<Loading />}>
                <Result />
            </Suspense>
        )
    },
    {
        path: '/shuttle-bus',
        component: (
            <Suspense fallback={<Loading />}>
                <ShuttleBus />
            </Suspense>
        )
    },
    {
        path: '/bus-detail',
        component: (
            <Suspense fallback={<Loading />}>
                <BusDetail />
            </Suspense>
        )
    },
    {
        path: '/bus-orders',
        component: (
            <Suspense fallback={<Loading />}>
                <BusOrderList />
            </Suspense>
        )
    },
    {
        path: '/pdf',
        component: (
            <Suspense fallback={<Loading />}>
                <Pdf />
            </Suspense>
        )
    },
    {
        path: '/voucher',
        component: (
            <Suspense fallback={<Loading />}>
                <Voucher />
            </Suspense>
        )
    },
    {
        path: '/customer',
        component: (
            <Suspense fallback={<Loading />}>
                <CustomerActivate />
            </Suspense>
        )
    },
    {
        path: '/benefits',
        component: (
            <Suspense fallback={<Loading />}>
                <Benefits />
            </Suspense>
        )
    },
    {
        path: '/benefits/intro',
        component: (
            <Suspense fallback={<Loading />}>
                <BenefitsIntro />
            </Suspense>
        )
    },
    {
        path: '/benefits/outlet',
        component: (
            <Suspense fallback={<Loading />}>
                <BenefitsOutlet />
            </Suspense>
        )
    }
]

export default routeMap
